// extracted by mini-css-extract-plugin
export default {"wrapper":"HealthCheckAutoInvite_wrapper__h9pbL","tableContainer":"HealthCheckAutoInvite_tableContainer__w+3vh","noResults":"HealthCheckAutoInvite_noResults__2sNOX"};